import { ISortDirection } from "../../models";

export const UPDATE_SORT = 'UPDATE_SORT';

export type sortingPayload = {
  pageName: string;
  environment: string;
  sort?: any;
  sortDirection?: { [key: string]: ISortDirection };
};

export type SortingAction = {
  type: string;
  payload: sortingPayload;
};

export const updateSort = (item: sortingPayload) => ({
    type: UPDATE_SORT,
    payload: item
  });
  